const CreateLink = ({ item, navigateToUrl, children, ...props }) => {
    const id = `alli-sidebar-${item.id || item.name}`;

    // things in SPA need to be handled via `navigateToUrl` so the whole
    // page doesn't re-render.
    if (item.isSpa) {
        return (
            <a id={id} href={item.href} onClick={navigateToUrl} {...props}>
                {children}
            </a>
        );
    }

    return (
        <a data-testid={id} href={item.href} {...props}>
            {children}
        </a>
    );
};

export default CreateLink;
